<template>
    <div style="position: relative; height: auto; width: 100%; overflow: hidden;">
        <div v-if="!cameraCarregada" class="loading-camera">
            <img src="../assets/loading.gif" alt="" style="height: 40px;" />
        </div>
        <video
            v-show="cameraCarregada"
            id="barcode-video"
            autoplay
            playsinline
            style="width: 100%; height: 100%; object-fit: contain; background-color: black;clip-path: polygon(0% 25%, 100% 25%, 100% 75%, 0% 75%);transform: translateY(-25%);"
        ></video>
    </div>
</template>

<script>
export default {
    name: "BarcodeQuaggaComponent",
    data() {
        return {
            qua: null,
            videoElement: null,
            cameraCarregada: false,
        };
    },
    created() {
        this.conso();
    },
    beforeDestroy() {
        console.log("BarcodeQuaggaComponent being destroyed");
        if (this.qua) {
            this.qua.stop();
            this.qua.offDetected();
        }
        
        // Também pare a câmera manualmente
        const stream = this.videoElement?.srcObject;
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
            this.videoElement.srcObject = null;
        }
    },
    methods: {
        conso() {
            setTimeout(() => {
                this.videoElement = document.querySelector("#barcode-video");

                // Solicitar permissão para acessar a câmera
                navigator.mediaDevices
                    .getUserMedia({
                        video: {
                            facingMode: "environment", // Usar câmera traseira
                        },
                    })
                    .then((stream) => {
                        // Exibir o fluxo de vídeo no elemento <video>
                        if (this.videoElement) {
                            this.videoElement.srcObject = stream;
                            this.videoElement.addEventListener("canplay", () => {
                                this.cameraCarregada = true;
                            }, { once: true });
                        }

                        // Inicializar o Quagga
                        this.qua = window.Quagga;
                        this.qua.init(
                            {
                                inputStream: {
                                    name: "Live",
                                    type: "LiveStream",
                                    target: this.videoElement, // Elemento <video>
                                    constraints: {
                                        width: window.innerWidth,
                                        facingMode: "environment", // Câmera traseira
                                    },
                                },
                                decoder: {
                                    readers: ["code_39_reader", "code_128_reader"], // Tipos de códigos suportados
                                },
                            },
                            (err) => {
                                if (err) {
                                    console.error("Erro ao inicializar o Quagga:", err);
                                    return;
                                }
                                console.log("Quagga inicializado com sucesso");
                                this.qua.start(); // Inicia o scanner
                            }
                        );

                        // Callback após detecção de código
                        this.qua.onDetected((data) => {
                            if (data && data.codeResult) {
                                console.log("Código detectado: ", data.codeResult.code);
                                localStorage.setItem("barcode", data.codeResult.code);
                                this.iDidIt(data.codeResult.code);
                                this.qua.stop();
                                this.qua.offDetected();
                            }
                        });
                    })
                    .catch((error) => {
                        console.error("Erro ao acessar a câmera:", error);
                    });
            }, 800);
        },
        iDidIt(code) {
            console.log("%cI did it :: " + code, "color: yellow");
            this.$emit("onDetected", code);
        },
    },
};
</script>

<style scoped>
.loading-camera {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    background: white;
}
</style>